/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetUniverseStationsStationIdNotFound
 */
export interface GetUniverseStationsStationIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetUniverseStationsStationIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetUniverseStationsStationIdNotFound interface.
 */
export function instanceOfGetUniverseStationsStationIdNotFound(value: object): value is GetUniverseStationsStationIdNotFound {
    return true;
}

export function GetUniverseStationsStationIdNotFoundFromJSON(json: any): GetUniverseStationsStationIdNotFound {
    return GetUniverseStationsStationIdNotFoundFromJSONTyped(json, false);
}

export function GetUniverseStationsStationIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseStationsStationIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetUniverseStationsStationIdNotFoundToJSON(json: any): GetUniverseStationsStationIdNotFound {
    return GetUniverseStationsStationIdNotFoundToJSONTyped(json, false);
}

export function GetUniverseStationsStationIdNotFoundToJSONTyped(value?: GetUniverseStationsStationIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

